import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';
import { fg } from '@atlaskit/platform-feature-flags/fg';

import { filterCommonAttributes } from './analytics-helpers';
import { toHttpErrorCategory } from './http-error-category';
import type { commonAttributesType } from './types';

// When there is no ai generated answer to the question
export const onAIAnswerNotShown: ({
	isStreamed,
	loadTime,
	fmpLoadTime,
	...props
}: commonAttributesType & {
	isStreamed: boolean;
	loadTime?: number;
	fmpLoadTime?: number;
}) => AnalyticsEventPayload = ({
	isStreamed,
	loadTime,
	fmpLoadTime,
	...props
}: commonAttributesType & {
	isStreamed: boolean;
	loadTime?: number;
	fmpLoadTime?: number;
}): AnalyticsEventPayload => {
	const {
		query,
		answerString,
		source,
		errorState,
		errorCode,
		networkErrorReason,
		networkErrorDetails,
		backendFailureType,
		networkErrorDiagnosticType,
		networkErrorFailureStage,
		responseContentType,
		networkErrorTraceId,
		streamEventsReceived,
		networkErrorDuration,
		extraAttributes,
	} = props;
	return {
		action: 'shown',
		actionSubject: 'aiAnswerError',
		source: source,
		eventType: 'track',
		attributes: {
			...filterCommonAttributes(props),
			isStreamed,
			loadTime,
			fmpLoadTime,
			errorState,
			...(fg('kd_granular_network_errors') && {
				errorCode,
				...(fg('kd_http_error_status_propagation') && {
					httpErrorCategory: toHttpErrorCategory(errorCode),
				}),
				networkErrorReason,
				networkErrorDetails,
				// Prefer the trace id captured from the backend error response (e.g.
				// Stargate's atl-traceid) so failures can be correlated with
				// backend/gateway logs; fall back to the client request id.
				traceId: networkErrorTraceId ?? extraAttributes?.requestId,
				backendFailureType,
				streamEventsReceived,
				networkErrorDuration,
			}),
			...(fg('kd_sain_stream_error_diagnostics') && {
				networkErrorDiagnosticType,
				networkErrorFailureStage,
				responseContentType,
				...(networkErrorTraceId && { traceId: networkErrorTraceId }),
			}),
		},
		nonPrivacySafeAttributes: {
			query,
			answerString,
		},
	};
};
